import reportMasterService from "@/api/reportMasterService";
import router from '@/router/index';

const state = {
    reportMasterList: [],
    loader: false,
    initialData: {},
    ParentGroupIdData:{},
    newReport: {},
}

const getters = {
    getEditReport: state => state.newReport,
};

const actions ={

    async getAllReports({ commit,state }) {
        state.loader = true;
        const response = await reportMasterService.getAllReports();
        state.loader=false
        commit('get', response.data.result)
    },

    async getInitialData({commit, state}) {
        state.loader=true
        const response = await reportMasterService.getInitialData();
        state.loader=false
        commit('getInitialData', response.data)
    },

    async getParentReportById({commit,state}){
        state.loader=true
        const response = await reportMasterService.getParentReportById();
        state.loader=false
        commit('getParentReportById', response.data.result)
    },

    async addReportMaster({ commit }, report) {
        state.loader = true;
        const response = await reportMasterService.addReportMaster(report);
        if (response.data.status) {
            commit('addReportMaster', response.data.result, { root: true });
        } 
        return response.data;
    },

    async editReportMaster({ commit }, report) {
        state.loader = true;
        const response = await reportMasterService.getParticularReportById(report)
        commit('edit', response.data.result)
    },

    async updateReportMaster({ commit }, report) {
        state.loader = true;
        const response = await reportMasterService.updateReport(state.editId, report);
        commit('updateReport', response.data.result, { root: true });
        return response.data;
    },
    async deleteReportMaster({ commit }, report) {
        const reportDeleteData= {
            ReportIds:[report.dataItem.id]
        };
        await reportMasterService.deleteReport(reportDeleteData);
       commit('removeReport', report.dataItem.id);
    },
};

const mutations ={
  
    get(state, reports) {
        state.reportMasterList = reports;
    },
    getInitialData(state, data) {
        state.initialData = data;
    },
    getParentReportById(state,data){
         state.ParentGroupIdData=data;
    },
    
    edit(state,  report) {
        state.editId = report.id
        state.newReport = report
      
        router.push({ name: "reportMasterAdd", params: { add: false } });
    },
    removeReport(state,report){
        const index = state.reportMasterList.findIndex((d) => d.id === report);
        state.reportMasterList.splice(index, 1);
    },
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}